import { render } from "./desktop.vue?vue&type=template&id=f2f0ebdc&scoped=true"
import script from "./desktop.vue?vue&type=script&lang=js"
export * from "./desktop.vue?vue&type=script&lang=js"

import "./desktop.vue?vue&type=style&index=0&id=f2f0ebdc&lang=scss&scoped=true"
import "./desktop.vue?vue&type=style&index=1&id=f2f0ebdc&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f0ebdc"]])

export default __exports__